import { Auth } from 'aws-amplify';

export async function getUser() {
  return Auth.currentAuthenticatedUser();
}
